import { TranslatedCalling } from './common';

export const think = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.think.reasoning" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.think.reasoning" />,
  result: () => null,
};
